<template>
  <div class="w-full">
    <Toast position="top-center" />
    <ScrollTop :threshold="200" />

    <transition name="page" mode="out-in" appear>
      <div :key="$page.url" class="general-container my-2">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
import { Inertia } from "@inertiajs/inertia";
import Toast from "primevue/toast";
import ScrollTop from "primevue/scrolltop";

export default {
  components: { Toast, ScrollTop },
  methods: {
    //
  },
  data() {
    return {
      //
    };
  },
  mounted() {
    window.addEventListener("popstate", (event) => {
      let reload_components = null;

      switch (this.$page.component) {
        case "ShoppingCart/View":
          reload_components = ["flash", "shopping_cart"];
          break;

        default:
          reload_components = ["flash"];
          break;
      }

      event.stopImmediatePropagation();

      Inertia.reload({
        preserveState: true,
        preserveScroll: true,
        only: reload_components,
        onError: () => (window.location.href = event.state.url),
      });
    });
  },
};
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.1s;
}

.page-enter,
.page-leave-active {
  opacity: 0;
}
</style>

<style lang="postcss">
.header {
  @apply general-container mt-10 mb-4 flex flex-wrap justify-between items-end;
}

.footer {
  @apply w-full mt-10 p-10 pb-4 bg-fh-blue text-white text-center;
  @apply bg-no-repeat bg-contain bg-[center_bottom_1rem] bg-[length:35vmin_auto];
  @apply sm:bg-[length:auto_85%] sm:bg-[left_1rem_bottom_1rem];
  /* background-image: url("/images/foody-home-footer-250x300.png"); */
}

.p-menubar {
  @apply p-0 border-0;
}

.p-menubar .p-menuitem-link {
  @apply text-fh-blue;
}

.general-container {
  @apply max-w-screen-lg mx-auto px-4;
}

.search-box {
  @apply text-sm px-2;
}

.login-text {
  @apply text-sm text-fh-gray-light px-2 py-1;
}

.shopping-info {
  @apply text-lg text-fh-blue;
}

hr {
  @apply text-fh-blue;
}
</style>